import React from 'react';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import CardBody from '../../shared/components/CardBody';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { Field, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import * as profileActions from '../actions/profileActions';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { PsRoutes } from '../../shared/routing/Routes';
import { FormText } from '../../shared/components/FormText';
import { FormSubmit } from '../../shared/components/FormSubmit';
import { FormSelect } from '../../shared/components/FormSelect';
import { CurrentUser } from '../../shared/model/CurrentUser';
import { PsCompanyManagement } from '../../shared/model/PsCompanyManagement';

const FORM = {
    NAME: 'ProfileForm',
    FIELDS: {
        PROFILE_NAME: 'name',
        PROFILE_SURNAMES: 'surnames',
        PROFILE_EMAIL: 'email',
        PROFILE_HOME_SCREEN: 'homeScreen',
        SUBMIT: 'submit',
    },
};

const homeScreensByRole = {
    CONTRACTOR_ADMIN: [
        {
            label: I18nUtils.tr('TR_MIS_CONTRATISTAS'),
            value: PsCompanyManagement.MY_CONTRACTORS,
        },
        {
            label: I18nUtils.tr('TR_MIS_SUBCONTRATAS'),
            value: PsCompanyManagement.MY_OUTSOURCES,
        },
    ],
};

class ProfileFormCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userImage: '',
        };
    }

    componentDidMount() {
        const { currentUser } = this.props;
        this.setState({ userImage: currentUser.image() });
    }

    render() {
        const {
            loading,
            handleSubmit,
            currentUser,
        } = this.props;

        return (
            <Row>
                <Card loading={loading}>
                    <CardBody>
                        <form onSubmit={handleSubmit(this.onSubmit)}>
                            <div className="round-image m-b-20">
                                <input
                                    ref="hiddenFileInput"
                                    type="file"
                                    style={{ display: 'none' }}
                                    accept="image/*"
                                    onChange={this.onImageChanged}
                                />
                                <img
                                    ref="imagePreview"
                                    src={this.state.userImage}
                                    alt={'UserImage'}
                                    width="48"
                                    height="48"
                                    className="m-r-5"
                                />
                                <button
                                    type="button"
                                    name="button"
                                    onClick={this.triggerImageInput}
                                    children="Cambiar foto"
                                    className="btn btn-link"
                                />
                            </div>
                            <Row>
                                <Field
                                    col="col-md-12"
                                    name={FORM.FIELDS.PROFILE_NAME}
                                    label={I18nUtils.tr('TR_NOMBRE')}
                                    component={FormText}
                                    placeholder={I18nUtils.tr('TR_NOMBRE')}
                                />
                            </Row>
                            <Row>
                                <Field
                                    col="col-md-12"
                                    name={FORM.FIELDS.PROFILE_SURNAMES}
                                    label={I18nUtils.tr('TR_APELLIDO_S')}
                                    component={FormText}
                                    placeholder={I18nUtils.tr('TR_APELLIDO_S')}
                                />
                            </Row>
                            <Row>
                                <Field
                                    col="col-md-12"
                                    name={FORM.FIELDS.PROFILE_EMAIL}
                                    label={I18nUtils.tr('TR_EMAIL')}
                                    component={FormText}
                                    placeholder={I18nUtils.tr('TR_EMAIL')}
                                />
                            </Row>
                            {
                                currentUser.isAdmin() ? (
                                    <Row>
                                        <Field
                                            col="col-sm-12"
                                            name={FORM.FIELDS.PROFILE_HOME_SCREEN}
                                            label={I18nUtils.tr('TR_VENTANA_DE_INICIO_PREDETERMINADA')}
                                            options={this.homeScreens()}
                                            displayEmptyOption={false}
                                            component={FormSelect}
                                        />
                                    </Row>
                                ) : null
                            }
                            <Row>
                                <div className="col-xs-8 p-t-5">
                                    <Link
                                        to={PsRoutes.PROFILE_PASSWORD_EDIT}
                                        children={I18nUtils.tr('TR_CAMBIA_TU_CONTRASENA')}
                                    />
                                </div>
                                <Field
                                    col="col-xs-4"
                                    name={FORM.FIELDS.SUBMIT}
                                    label={I18nUtils.tr('TR_GUARDAR').toUpperCase()}
                                    component={FormSubmit}
                                />
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            </Row>
        );
    }

    onSubmit = (values) => {
        const user = parseToUser(values, this.props);
        const imageFile = this.refs.hiddenFileInput.files.length > 0 ? this.refs.hiddenFileInput.files[0] : null;
        this.props.profileActions.updateProfile(user, imageFile);
    };

    triggerImageInput = () => {
        this.refs.hiddenFileInput.click();
    };

    onImageChanged = (e) => {
        const input = e.target;
        const url = input.value;
        const ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();

        if ( input.files && input.files[0] && ( ext === 'gif' || ext === 'png' || ext === 'jpeg' || ext === 'jpg' ) ) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.setState({
                    userImage: e.target.result,
                });
            };

            reader.readAsDataURL(input.files[0]);
        }
    };

    homeScreens = () => {
        return homeScreensByRole.CONTRACTOR_ADMIN;
    };
}

const parseToUser = (values, props) => {
    return {
        id: props.currentUser.id(),
        name: values.name || undefined,
        last_name: values.surnames || undefined,
        email: values.email || undefined,
        home_screen: ( values.homeScreen && values.homeScreen[0] && values.homeScreen[0].value ) || undefined,
    };
};

const validate = (values) => {
    const {
        name,
        surnames,
        email,
    } = values;

    const errors = {};
    const emptyError = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');

    if ( !name ) errors.name = emptyError;
    if ( !surnames ) errors.surnames = emptyError;
    if ( !email ) errors.email = emptyError;

    return errors;
};

const mapStateToProps = (state, ownProps) => {
    const user = ownProps.user ? ownProps.user : state.auth.user;
    const homeScreen = user
        ? homeScreensByRole.CONTRACTOR_ADMIN.filter((opt) => opt.value === user.home_screen)
        : [];

    const initialValues = {
        name: user ? user.name : undefined,
        surnames: user ? user.last_name : undefined,
        email: user ? user.email : undefined,
        homeScreen,
    };

    return {
        loading: state.formProfile.loading,
        currentUser: CurrentUser.fromReduxState(state),
        initialValues,
    };
};

const mapDispatchToProps = dispatch => ( {
    profileActions: bindActionCreators(profileActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(
    reduxForm(
        {
            validate,
            form: FORM.NAME,
            enableReinitialize: true,
        },
    )(ProfileFormCard),
);

ProfileFormCard.propTypes = {};

ProfileFormCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/profile/components/ProfileFormCard.jsx